import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

export default class extends Controller {
  connect() {
    // Add an event listener for changes in color scheme if theme switch
    window.matchMedia("(prefers-color-scheme: dark)").addListener(() => {
      this.initializeChart()
      this.updateChartTheme()
    })

    // Initial setup
    this.initializeChart()
    this.updateChartTheme()
  }

  initializeChart() {
    const options = {
      series: [
        {
          name: "Last year",
          data: [
            224, 225, 225, 226, 229, 222, 254, 256, 257, 258, 259, 253, 266,
            261, 265,
          ],
          type: "area",
        },
        {
          name: "Year to date",
          data: [
            223, 234, 239, 240, 241, 242, 245, 250, 263, 273, 265, 285, 278,
            290, 320,
          ],
          type: "area",
        },
      ],
      chart: {
        type: "area",
        sparkline: { enabled: true },
        height: "380px",
        theme: {
          mode: this.isDarkMode() ? "dark" : "light",
        },
        background: "transparent",
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        lineCap: "round",
      },
      legend: {
        show: false,
      },
      colors: ["#9458F6", "#52A5AF"],
      yaxis: {},
      labels: [
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
      ],

      tooltip: {
        shared: true,

        x: {
          show: true,
          format: "dd/MM/yy",
        },
      },
    }

    this.chart = new ApexCharts(this.element, options)
    this.chart.render()
  }

  updateChartTheme() {
    const newTheme = this.isDarkMode() ? "dark" : "light"
    if (this.chart) {
      this.chart.updateOptions({
        theme: {
          mode: newTheme,
        },
        chart: {
          background: "transparent",
        },
      })
    }
  }

  isDarkMode() {
    return (
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
    )
  }
}
